import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import senerfiBlanco from '../assets/images/senerfiblanco.png';
import { useWarehouse } from '../Components/useWarehouse/useWarehouse';
import { Header } from '../Components/Layout/Header';
import { Navigation } from '../Components/Layout/Navigation';
import { MaterialsModule } from '../Components/warehouse/MaterialsModule';
import { StockModule } from '../Components/warehouse/StockModule';
// import { PeopleModule } from '../Components/warehouse/PeopleModule';
import { PendingOrdersModule } from '../Components/warehouse/PendingOrdersModule';
import { EntryModule } from '../Components/warehouse/EntryModule';
import { AssignmentModule } from '../Components/AssignmentModule/AssignmentModule';
import { ReturnModule } from '../Components/ReturnModule/ReturnModule';
import { ExitModule } from '../Components/warehouse/ExitModule';
import { TransferModule } from '../Components/warehouse/TransferModule';
import { MovementsModule } from '../Components/warehouse/MovementsModule';
import BrandCopyright from '../Components/Common/BrandCopyright';

export default function Almacen() {
  const { location } = useParams();
  const navigate = useNavigate();
  const [activeModule, setActiveModule] = useState('all');
  const {
    materials,
    brandItems,
    people,
    movements,
    assignments,
    addMaterial,
    updateMaterial,
    deleteMaterial,
    registerEntry,
    registerBulkEntry,
    registerAssignment,
    registerReturn,
    registerExit,
    registerTransfer,
    warehouses,
    movementsRefreshKey,
  } = useWarehouse();

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header tipo inicio de pÃ¡gina con logo */}
      <div className="w-full shadow-md" style={{ backgroundColor: '#F07E2D' }}>
        <div className="max-w-6xl mx-auto flex items-center h-14 px-4">
          <img src={senerfiBlanco} alt="Senerfi" className="h-8 w-auto" />
        </div>
      </div>

      {/* Encabezado propio del mÃ³dulo */}
      <Header
        rightSlot={(
          <button
            type="button"
            className="text-sm text-white px-4 py-2 rounded-lg hover:opacity-90 focus:outline-none"
            style={{ backgroundColor: '#776F74' }}
            onClick={() => navigate(`/sede/${location}`)}
          >
            Volver a Sede
          </button>
        )}
      />

      {/* NavegaciÃ³n de submÃ³dulos */}
      <Navigation activeModule={activeModule} setActiveModule={setActiveModule} />

      {/* Contenido principal */}
      <div className="p-6 flex items-center justify-center">
        <div className="bg-white rounded-2xl shadow-2xl border border-gray-200 p-8 max-w-5xl w-full">
          {activeModule === 'all' && (
            <div className="space-y-10">
              <MaterialsModule
                materials={materials}
                onAdd={addMaterial}
                onUpdate={updateMaterial}
                onDelete={deleteMaterial}
              />

              {/* Personas oculto en Almacén: se gestiona únicamente desde Recursos Humanos */}

              <PendingOrdersModule
                location={location}
                materials={materials}
                people={people}
                warehouses={warehouses}
                onApproveAssign={registerAssignment}
              />

              <EntryModule
                materials={materials}
                warehouses={warehouses}
                onRegister={registerEntry}
                onRegisterBulk={registerBulkEntry}
                onNewAssignment={() => setActiveModule('assignment')}
              />

              <AssignmentModule
                materials={materials}
                people={people}
                assignments={assignments}
                brandItems={brandItems}
                movements={movements}
                warehouses={warehouses}
                onRegister={registerAssignment}
                initialType="Asignación"
              />

              <AssignmentModule
                materials={materials}
                people={people}
                assignments={assignments}
                brandItems={brandItems}
                movements={movements}
                warehouses={warehouses}
                onRegister={registerAssignment}
                onReturn={registerReturn}
                initialType="Préstamo"
              />

              <ReturnModule
                assignments={assignments}
                materials={materials}
                people={people}
                warehouses={warehouses}
                onRegister={registerReturn}
              />

              <ExitModule
                materials={materials}
                warehouses={warehouses}
                onRegister={registerExit}
              />

              <MovementsModule refreshKey={movementsRefreshKey} />
            </div>
          )}

          {activeModule === 'materials' && (
            <MaterialsModule
              materials={materials}
              onAdd={addMaterial}
              onUpdate={updateMaterial}
              onDelete={deleteMaterial}
            />
          )}

          {activeModule === 'stock' && (
            <StockModule
              materials={materials}
              warehouses={warehouses}
              onAdd={addMaterial}
              onUpdate={updateMaterial}
              onDelete={deleteMaterial}
            />
          )}


          {/* Sección 'people' deshabilitada en Almacén */}

          {activeModule === 'pending' && (
            <PendingOrdersModule
              location={location}
              materials={materials}
              people={people}
              warehouses={warehouses}
              onApproveAssign={registerAssignment}
            />
          )}

          {activeModule === 'entry' && (
            <EntryModule
              materials={materials}
              warehouses={warehouses}
              onRegister={registerEntry}
              onRegisterBulk={registerBulkEntry}
              onNewAssignment={() => setActiveModule('assignment')}
            />
          )}

          {activeModule === 'assignment' && (
            <AssignmentModule
              materials={materials}
              people={people}
              assignments={assignments}
              brandItems={brandItems}
              movements={movements}
              warehouses={warehouses}
              onRegister={registerAssignment}
              initialType="Asignación"
            />
          )}

          {activeModule === 'loan' && (
            <AssignmentModule
              materials={materials}
              people={people}
              assignments={assignments}
              brandItems={brandItems}
              movements={movements}
              warehouses={warehouses}
              onRegister={registerAssignment}
              onReturn={registerReturn}
              initialType="Préstamo"
            />
          )}

          {activeModule === 'return' && (
            <ReturnModule
                assignments={assignments}
                materials={materials}
                people={people}
                warehouses={warehouses}
                onRegister={registerReturn}
              />
          )}

          {activeModule === 'exit' && (
            <ExitModule
              materials={materials}
              warehouses={warehouses}
              onRegister={registerExit}
            />
          )}

          {activeModule === 'transfer' && (
            <TransferModule
              materials={materials}
              brandItems={brandItems}
              warehouses={warehouses}
              onRegister={registerTransfer}
            />
          )}

          {activeModule === 'movements' && (
            <MovementsModule refreshKey={movementsRefreshKey} />
          )}
        </div>
      </div>

      {/* Pie de pÃ¡gina reutilizable */}
      <BrandCopyright />
    </div>
  );
}
